module.exports = __webpack_public_path__ + "static/media/paypal-setting.3a358b66.png";